import { proxy } from 'valtio';

export const defaultPageTitle = 'Fabric';

export const currentPageTitle: Record<string, string> = proxy({
  title: defaultPageTitle,
});

export const updatePageTitle = (title: string) =>
  (currentPageTitle.title = `${title} — Fabric`);

export const normalizePageTitle = (title: string) => {
  return title.split('— Fabric').shift() ?? currentPageTitle.title;
};
